import axios from 'axios'

import type { components } from '../constants/schema'

/**
 * 본인인증 UUID 생성
 * @returns identityVerificationId | null
 */
export const getIdentityVerificationId = async () => {
  try {
    const { identityVerificationId } = (
      await axios.get<components['schemas']['ResIdentityVerificationId']>('/identification/identityVerificationId')
    ).data

    return identityVerificationId ?? null
  } catch (error) {
    console.log({ error })
    return null
  }
}

/**
 * 본인인증 요청
 * @param data ReqQueryIdentication
 * @returns IdentificationDto
 */
export const identify = async (data: components['schemas']['ReqQueryIdentication']) => {
  try {
    return (await axios.post<components['schemas']['IdentificationDto']>('/identification/identify', data)).data
  } catch (error) {
    throw error
  }
}
